import { shuffle, sample } from 'lodash';

const TARGET_ELAPSED = 1000 / 60;

class MessageBoard extends Phaser.Group {
  currentAnimation = null;
  queue = [];
  style = 'scroll';

  constructor(game, x, y, bounds, options = {}) {
    super(game, null, 'message-board');
    this.x = x;
    this.y = y;
    this.frame = 0;
    this.textureBounds = bounds;
    this.queue = options.queue || ['DEFAULT MESSAGE POOL'];
    this.frameRate = options.frameRate || 60;
    this.updateFrequency = Math.floor(60 / this.frameRate);
    this.speed = options.speed || 1.5;
    this.txt = this.game.add.bitmapText(0, 0, 'panton_green', '', 22, this);
    this.mask = this.makeMask();
    this.tx = this.textureBounds.width;
  }

  destroy() {
    if (this.currentAnimation) this.currentAnimation.kill();
    this.queue = [];
  }

  update() {
    if (this.isScrolling && ++this.frame % this.updateFrequency === 0) {
      this.txt.x -= this.game.time.elapsedMS / TARGET_ELAPSED * (this.speed * this.updateFrequency);
      if (this.txt.x < -this.txt.width) {
        this.handleMessageComplete();
      }
    }
  }

  makeMask() {
    const { x, y, width, height } = this.textureBounds;
    const g = this.game.make.graphics(0, 0);
    this.addChild(g);
    g.beginFill(0xff0000);
    g.drawRect(x, y, width, height);
    return g;
  }

  handleMessageComplete() {
    const message = this.queue.shift(); // remove first element
    this.queue.push(message);
    this.animate();
  }

  animate() {
    if (this.currentAnimation) this.currentAnimation.kill();
    this.txt.text = this.queue[0].toUpperCase();
    this.txt.x = this.textureBounds.width;
    this.currentAnimation = this.makeAnimation(this.style);
  }

  makeAnimation(style) {
    const animations = {
      scroll: this.scroll,
      pulse: this.pulse,
      pulseInfinite: () => {
        this.pulse(true);
      },
    };
    return animations[style].apply(this);
  }

  scroll() {
    this.isScrolling = true;
    return {
      kill: () => {
        this.isScrolling = false;
      },
    };
  }

  handleScrollComplete = () => {
    this.handleUpdate();
    if (this.txt.x < -this.txt.width) {
      this.handleMessageComplete();
    } else {
      this.currentAnimation = this.scroll();
    }
  };

  pulse(infinite = false) {
    this.txt.x = (this.textureBounds.width - this.txt.width) / 2;
    return new TimelineMax({
      repeat: infinite ? -1 : 4,
      onComplete: this.handleMessageComplete,
      onCompleteScope: this,
    })
      .call(this.handleUpdate)
      .set(this.txt, { alpha: 0 }, 0.6)
      .call(this.handleUpdate)
      .set(this.txt, { alpha: 1 }, 1);
  }

  setMessage(message, style = 'scroll') {
    this.style = style;
    this.queue.unshift(message);
    this.animate();
  }

  pushMessage(message) {
    this.queue.push(message);
  }

  shuffleQueue() {
    this.queue = shuffle(this.queue);
  }
}

export default MessageBoard;
